import {FETCH_FOOTER_REQUEST, FETCH_FOOTER_SUCCES, FETCH_FOOTER_ERROR} from '../constants/Footer'

const initialState = {
  list: [],
  hasErrored: false,
  isLoading: false
}

export default function footer(state = initialState, action) {
  switch (action.type) {
    case FETCH_FOOTER_REQUEST:
      return {...state, isLoading: true};
    case FETCH_FOOTER_SUCCES:
      return {...state, list: action.payload.results, isLoading: false};
    case FETCH_FOOTER_ERROR:
      return {...state, hasErrored: true, isLoading: false};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/footer.js